import { createContext, ReactNode, useState } from "react";

type AuthUser = {
  user?: {
    id: string;
    name: string;
    email: string;
  };
};

type AuthContextType = {
  auth: AuthUser;
  login: (email: string, password: string) => Promise<void>;
  logout: () => void;
};

const AuthContext = createContext<AuthContextType | undefined>(undefined);

type AuthProviderProps = {
  children: ReactNode;
};

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const [auth, setAuth] = useState<AuthUser>({});

  const login = async (email: string, _password: string) => {
    // 가짜 사용자 정보
    const fakeUser = {
      user: {
        id: "12345",
        name: "홍길동",
        email: email,
      },
    };
    alert("로그인 되었습니다.");
    setAuth(fakeUser); // 가짜 사용자 정보를 상태에 저장
  };

  const logout = () => {
    alert("로그아웃 되었습니다.");
    setAuth({}); // 상태를 초기화
  };

  return (
    <AuthContext.Provider value={{ auth, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
